import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import { routes } from './routes';

Vue.use(VueRouter)

Vue.config.productionTip = false
const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      }
    }
    return { x: 0, y: 0 }
  },
	mode: 'history'
});
new Vue({
  router,
  render: function (h) { return h(App) },
}).$mount('#app')

Vue.use(VueRouter);



